
import { Briefcase, GraduationCap, Heart } from "lucide-react";

import SEO from "@/components/SEO";
import { CONTACT } from "@/lib/constants";

const PERKS = [
  { icon: Briefcase, title: "Real Pharma Exposure", desc: "Work alongside formulators, QC scientists and manufacturing experts on real veterinary products." },
  { icon: GraduationCap, title: "Continuous Learning", desc: "GMP training, scientific seminars and structured career development at every level." },
  { icon: Heart, title: "Purpose-Driven", desc: "Your work improves the health of animals and the livelihoods of farmers across India and abroad." },
];

export default function Careers() {

  return (
    <>
      <SEO title="Careers" description="Join Forage Animal Health & Nutrition — pharmaceutical-grade veterinary manufacturing careers in formulation, QC, production and operations." path="/careers" />

      <section className="bg-[#0B2545] text-white py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
        <div className="absolute inset-0 grid-pattern opacity-20" />
        <div className="container-fr relative">
          <span className="overline text-[#2A9D8F]">Careers at Forage</span>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-black mt-3 leading-tight max-w-3xl">
            Build a career in veterinary pharma. Make an impact that matters.
          </h1>
          <p className="text-lg text-slate-300 mt-6 max-w-2xl">
            We hire scientists, technicians, supply-chain professionals and
            field experts who want to do their best work in a modern Indian
            pharma environment.
          </p>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-fr grid md:grid-cols-3 gap-6">
          {PERKS.map((p, i) => (
            <div key={p.title} className="p-7 rounded-xl border border-slate-200 card-lift fade-up" style={{ animationDelay: `${i * 60}ms` }}>
              <div className="w-11 h-11 rounded-lg bg-[#0B2545] text-[#2A9D8F] flex items-center justify-center mb-5">
                <p.icon size={22} />
              </div>
              <h3 className="font-display text-xl font-bold text-[#0B2545]">{p.title}</h3>
              <p className="text-sm text-slate-600 mt-3 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section-padding bg-[#F8FAFC]">
        <div className="container-fr max-w-3xl">
          <span className="overline">Apply Now</span>
          <h2 className="h-section mt-3">Send us your resume.</h2>
          <p className="text-slate-600 mt-4">
            Don't see an open role that fits? Send us your resume — we keep
            promising profiles on file.
          </p>

          <div className="mt-10 bg-white p-8 rounded-xl border border-slate-200 shadow-sm">
            <p className="text-slate-700 leading-relaxed mb-6">Email your CV (PDF or DOCX) and mention the position you are applying for. A member of the Forage team can then review your application.</p>
            <a href={`mailto:${CONTACT.email}?subject=${encodeURIComponent("Career application - Forage Animal Health")}`} className="btn-accent inline-flex items-center" data-testid="career-email-apply">Email Your CV</a>
            <p className="text-sm text-slate-500 mt-4">Your email application will not be sent until you attach your resume and press Send in your mail application.</p>
          </div>
        </div>
      </section>
    </>
  );
}
